(function () {
  if (window.__lumClinicAnalyticsLoaded) return;
  window.__lumClinicAnalyticsLoaded = true;
  var measurementId = window.__lumClinicMeasurementId || '';
  if (!/^G-[A-Z0-9]+$/.test(measurementId)) return;
  var configured = false;
  var pageViewed = false;
  function allowed() {
    try {
      return !!window.__lumConsentBridge && window.__lumConsentBridge.allowed() === true;
    } catch (e) { return false; }
  }
  function isJane(link) {
    try { var u = new URL(link.href, location.href); return u.protocol === 'https:' && u.hostname === 'luminateco.janeapp.com'; }
    catch (e) { return false; }
  }
  function hasBookingLink() {
    return Array.prototype.some.call(document.querySelectorAll('a[href]'), isJane);
  }
  function pageClass() {
    if (location.pathname === '/') return 'home';
    if (document.querySelector('.pract-bio')) return 'practitioner';
    if (document.querySelector('[data-clinic-wrap]') || /^\/(?:pages\/)?clinic\/?$/.test(location.pathname)) return 'clinic';
    if (/^\/pages\/contact\/?$/.test(location.pathname)) return 'contact';
    if (/^\/pages\/(bedford|dartmouth)\/?$/.test(location.pathname)) return 'store';
    return 'other';
  }
  function safePage() {
    return { page_location: 'https://luminateco.ca/clinic-source/' + pageClass(), page_title: 'Luminate clinic source', page_referrer: '' };
  }
  function configure() {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    if (!configured) {
      var options = safePage();
      options.groups = 'luminate_clinic';
      options.send_page_view = false;
      options.allow_google_signals = false;
      options.allow_ad_personalization_signals = false;
      window.gtag('config', measurementId, options);
      configured = true;
    }
    return true;
  }
  function pageView() {
    if (pageViewed || !configure()) return;
    var params = safePage();
    params.send_to = measurementId;
    params.source_page_class = pageClass();
    window.gtag('event', 'page_view', params);
    pageViewed = true;
  }
  function ready() {
    if (!hasBookingLink()) return;
    if (configure()) {
      if (pageClass() !== 'other') pageView();
      return;
    }
  }

  document.addEventListener('luminate:analytics-ready', ready);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || !isJane(link) || !configure()) return;
    pageView();
    var params = safePage();
    params.send_to = measurementId;
    params.source_page_class = pageClass();
    params.cta_placement = link.closest('header') ? 'header' : link.closest('footer') ? 'footer' : link.closest('main') ? 'main' : 'other';
    params.booking_provider = 'jane';
    window.gtag('event', 'clinic_book_click', params);
  }, true);
})();
